var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 23,
    viewBox: "0 0 102 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.12 7.61L9.78 15.5L13.5 7.61H19.56L11.55 23H7.92L0 7.61H6.12Z",
    fill: "#FDCF76"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9003 5.36H27.8203V9.14H34.2703V14.12H27.8203V23H21.9403V0.38H34.9003V5.36ZM38.4052 23V0.38H44.2852L55.1452 14.21V0.38H60.9952V23H55.1452L44.2852 9.17V23H38.4052ZM78.6091 5.36H71.6191V9.14H78.2191V14.12H71.6191V18.02H78.6091V23H65.7391V0.38H78.6091V5.36ZM88.7285 10.49H89.8385C90.9985 10.49 91.8885 10.25 92.5085 9.77C93.1285 9.29 93.4385 8.6 93.4385 7.7C93.4385 6.8 93.1285 6.11 92.5085 5.63C91.8885 5.15 90.9985 4.91 89.8385 4.91H88.7285V10.49ZM101.659 23H94.3385L88.7285 14.3V23H82.8485V0.38H91.9985C93.2585 0.38 94.3585 0.57 95.2985 0.95C96.2385 1.31 97.0085 1.81 97.6085 2.45C98.2285 3.09 98.6885 3.83 98.9885 4.67C99.3085 5.51 99.4685 6.41 99.4685 7.37C99.4685 9.09 99.0485 10.49 98.2085 11.57C97.3885 12.63 96.1685 13.35 94.5485 13.73L101.659 23Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c83541737fc05059a1b693f5e56f2401.svg";
export { ForwardRef as ReactComponent };